import React, { FC } from "react";
import Tooltip from "../../../../components/Tooltip/Tooltip";

import speakerOnIcon from "../../icons/speakerOn.svg";
import speakerOffIcon from "../../icons/speakerOff.svg";
import styles from "./soundControl.module.scss";

type SoundControlProps = {
  muted: boolean;
  volume: number;
  onMuteToggle: () => void;
  onVolumeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const SoundControl: FC<SoundControlProps> = ({
  muted,
  volume,
  onMuteToggle,
  onVolumeChange,
}) => (
  <div className={styles.soundControl}>
    <Tooltip text={muted ? "Unmute" : "Mute"} withoutTranslation>
      <button
        type="button"
        className={styles.iconButton}
        onClick={onMuteToggle}
        aria-label={muted ? "Unmute" : "Mute"}
      >
        <img
          src={muted || volume === 0 ? speakerOffIcon : speakerOnIcon}
          alt=""
          className={styles.volumeIcon}
        />
      </button>
    </Tooltip>
    <div className={styles.rangeWrap}>
      <div className={styles.track}>
        <div
          className={styles.fill}
          style={{ width: `${Math.min(1, Math.max(0, volume)) * 100}%` }}
        />
        <input
          type="range"
          min={0}
          max={1}
          step="0.01"
          value={volume}
          onChange={onVolumeChange}
          className={styles.slider}
          aria-label="Volume"
        />
      </div>
    </div>
  </div>
);

export default SoundControl;
